/**
 * The app prompt's copy, en-GB, verbatim from the Figma frames (TASK-1155
 * brief: "Тексты en-GB"). Kept out of the 87-locale catalogs on purpose:
 * every arm of the A/B test shows the same language, so a translation's
 * quality cannot leak into the comparison. The winning design gets
 * translated after the test.
 */
export interface PromptBenefit {
  /** The bold lead-in ("Offline map."). */
  readonly title: string
  /** The rest of the line. */
  readonly detail: string
}

export const PROMPT_COPY = Object.freeze({
  backToWeb: 'Go back to web',
  getTheApp: 'Get the App',
  continue: 'Continue',
  close: 'Close',
  home: {
    title: 'London is easier with the app',
    benefits: [
      { title: 'Offline map.', detail: 'View the Tube map, even underground.' },
      { title: 'Routes at your fingertips.', detail: 'Plan your journeys around London.' },
      { title: 'Quick access.', detail: 'Open the map with a single tap.' },
    ] satisfies readonly PromptBenefit[],
  },
  routeA: {
    title: 'Ready to go? Start your route on the app',
    benefits: [
      { title: 'Real-time.', detail: 'See live departures for your journey.' },
      { title: 'Faster.', detail: 'Find your route and the right platform.' },
      { title: 'Personalised.', detail: 'Get notified about delays & disruptions.' },
    ] satisfies readonly PromptBenefit[],
  },
  routeB: {
    /** "It's easier to get to {destination} with the app!" — destination in accent. */
    titleBefore: "It's easier to get to ",
    titleAfter: ' with the app!',
    subtitle: 'Take your route with you, with live departures and disruption updates.',
    /** "4.8 · 37 ratings" */
    ratings: (average: string, count: string) => `${average} · ${count} ratings`,
  },
  desktop1: {
    title: 'London is easier with the app',
    subtitle: 'Take the Tube map with you, wherever London takes you.',
    qrTitle: 'Scan to get the app',
    qrDetail: 'Use your phone’s camera',
  },
  desktop2: {
    title: 'Take London with you.',
    subtitle: 'Offline maps, easy route planning and quick access — all in one app.',
    qrTitle: 'Scan with your phone camera',
    qrDetail: 'Download the app and plan your next journey.',
  },
})
